export const COUNT = 'COUNT';
export const USD = 'USD';
